import axios from 'axios'
//获取机器货道列表
export const cellList = (data) => {
  return axios({
    url: '/mall/phone/cell/list/',
    method: 'post',
    data
  })
}

//货道开锁
export const cellOpen = (data) => {
  return axios({
    url: '/mall/phone/cell/open/',
    method: 'post',
    data
  })
}

//查询开锁结果
export const cellOpenQuery = (data) => {
  return axios({
    url: '/mall/phone/cell/open/query/',
    method: 'post',
    data
  })
}

//填满货道
export const cellFillAll = (data) => {
  return axios({
    url: '/mall/phone/cell/fill/all/',
    method: 'post',
    data
  })
}

//自定义补货
export const cellFillCustom = (data) => {
  return axios({
    url: '/mall/phone/cell/fill/custom/',
    method: 'post',
    data
  })
}
